import { UtilityMeterQuotaTier } from '../api/utilityMetersApi';

type TranslateFn = (key: string) => string;

export function resolveQuotaTierLevel(
  tier: UtilityMeterQuotaTier | string | number | undefined | null,
): number {
  if (typeof tier === 'number' && Number.isFinite(tier) && tier > 0) {
    return Math.floor(tier);
  }

  const raw = String(tier ?? '').trim().toUpperCase();
  const map: Record<string, number> = {
    TIER1: 1,
    TIER2: 2,
    TIER3: 3,
    TIER4: 4,
    DM1: 1,
    DM2: 2,
    DM3: 3,
    DM4: 4,
  };
  if (map[raw]) return map[raw];

  const labeled = raw.match(/(?:TIER|DM)(\d+)/);
  if (labeled) {
    const level = Number.parseInt(labeled[1], 10);
    if (Number.isFinite(level) && level > 0) return level;
  }

  return 1;
}

export function getQuotaTierLabel(
  tier: UtilityMeterQuotaTier | string | number | undefined,
  t: TranslateFn,
): string {
  const level = resolveQuotaTierLevel(tier);
  switch (level) {
    case 1:
      return t('quotaTier1');
    case 2:
      return t('quotaTier2');
    case 3:
      return t('quotaTier3');
    case 4:
      return t('quotaTier4');
    default:
      return `ĐM ${level}`;
  }
}

export function getQuotaTierShortLabel(
  tier: UtilityMeterQuotaTier | string | number | undefined | null,
): string {
  const level = resolveQuotaTierLevel(tier);
  return `ĐM ${level}`;
}

export function getBillingModeLabel(
  mode: 'QUOTA' | 'NON_QUOTA' | string | undefined,
  t: TranslateFn,
): string {
  return mode === 'QUOTA' ? t('billingModeQuota') : t('billingModeNonQuota');
}

export function getMeterStatusLabel(
  status: 'ACTIVE' | 'INACTIVE' | string | undefined,
  t: TranslateFn,
): string {
  return status === 'INACTIVE' ? t('meterStatusInactive') : t('meterStatusActive');
}

export function buildQuotaTierOptionsFromFeeTiers(
  feeTiers?: Array<{ tierLevel: number }>,
): number[] {
  if (!feeTiers?.length) {
    return [1, 2, 3, 4];
  }
  const levels = feeTiers
    .map((tier) => tier.tierLevel)
    .filter((level) => Number.isFinite(level) && level > 0);
  const unique = Array.from(new Set(levels)).sort((a, b) => a - b);
  return unique.length > 0 ? unique : [1, 2, 3, 4];
}
